
import {RequestDetail} from './requestDetail'
import {RequestMaterial} from './requestMaterial'


export class RequestAllDetails {

    //private _trackingId: string;
    private _details: RequestDetail;
    private _materials: RequestMaterial;
    private _model: any;
    constructor(private _modelDefined: any) {
        this._model = this._modelDefined ? angular.copy(this._modelDefined) : {};
        //this._trackingId = this._model.trackingId ? this._model.trackingId : undefined;
        this._details = this._model !== undefined && this._model.requestDetail ? new RequestDetail(this._model.requestDetail) : undefined;
        this._materials = this._model !== undefined && this._model.requestMaterial ? new RequestMaterial(this._model.requestMaterial) : undefined;
    }

    get trackingId(): string {
        return this._model.trackingId;
    }

    set trackingId(val: string) {
        this._model.trackingId = val;
    }

    get errorMessage(): string {
        return this._model.errorMessage;
    }

    set errorMessage(val: string) {
        this._model.errorMessage = val;
    }

    get details(): RequestDetail {
        return this._details;
    }

    set details(val: RequestDetail) {
        this._details = val;
    }

    get materials(): RequestMaterial {
        return this._materials;
    }

    set materials(val: RequestMaterial) {
        this._materials = val;
    }

}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetail/models/requestAllDetails.ts
 **/